import { Dimensions, FlatList, Image, Modal, PixelRatio, StyleSheet, Text, TextInput, TouchableOpacity, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import Colours from '../../utils/Colours';
import SearchIcon from '../../icons/SearchIcon';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import Toast from 'react-native-toast-message';
import toastConfig from '../../toasts/toastConfig';
import { useQuery } from '@tanstack/react-query';
import useAuth from '../../hooks/useAuth';
import CreateMeezaTransferTo from './CreateMeezaTransferTo';
import AppTextInput from '../../utils/ColourThemes/AppTextInput';

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const useCheckUsername = (username) => {
    const axiosPrivate = useAxiosPrivate();

    return useQuery({
        queryKey: ['userSearch', username],
        queryFn: async () => {
            if (!username.trim()) return null; // Don't fetch if input is empty

            const response = await axiosPrivate.get(`/userSearch/search/${username}`);
            return response.data.exists ? response.data : null;
        },
        enabled: !!username, // Only run query if username is not empty
        staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
        onError: (error) => {
            Toast.show({
                type: 'error',
                text1: 'Error Checking Username',
                text2: error.message || 'Something went wrong',
                visibilityTime: 4000,
            });
        },
    });
};

const TransferTo = () => {
    const [usernameSearchTxt, setUsernameSearchText] = useState('')
    const [isFormContainerClicked, setIsFormContainerClicked] = useState(false)
    const [showCreateMeezaTransferTo, setShowCreateMeezaTransferTo] = useState(false)
    const [username, setUsername] = useState('')
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [photo, setPhoto] = useState('')


    const { data: foundUser, isLoading, isLoadingError } = useCheckUsername(usernameSearchTxt);


    const axiosPrivate = useAxiosPrivate();

    const { sub } = useAuth()

    useEffect(() => {
        //console.log('foundUserxr', foundUser)
    }, [foundUser])

    const fetchUserFriends = async () => {
        const response = await axiosPrivate.get("/friends");
        //console.log('friends', response.data.friends)
        //console.log('Data.friends', response.data)

        return response.data.friends;
    };


    const { data: friendsList = [], isLoading: isLoading12, error } = useQuery({
        queryKey: ["userFriends"],
        queryFn: () => fetchUserFriends(),
        select: (data) => data.filter(friend => friend._id !== sub),
        onError: (err) => {
            //console.error("ERROR FRIENDS:", err);
            Toast.show({
                type: "error",
                text1: "Failed to load friends",
                text2: "Please try again later",
            });
        },
    });

    const handleMeezaTransferFriends = (friends) => {
        //console.log('frineds', friends)

        setUsername(friends.username);
        setFirstname(friends.firstname);
        setLastname(friends.lastname);
        setPhoto(friends.profilePicture);
        setShowCreateMeezaTransferTo(true)
    }


    const handleMeezaTransfer = () => {
        const username = foundUser.data.username;
        const photo = foundUser.data.profilePicture;
        const firstname = foundUser.data.firstname;
        const lastname = foundUser.data.lastname;

        setUsername(username);
        setFirstname(firstname);
        setLastname(lastname);
        setPhoto(photo);
        setShowCreateMeezaTransferTo(true)
    }
    return (
        <View style={styles.container}>
            <View style={styles.searchBox}>
                <View style={styles.JoinedNumber}>
                    <Text style={styles.titleTxt} >Search by username </Text>
                    <Text style={styles.sectionalTxt}>| :</Text>
                </View>
                <View style={styles.searchContainer}>
                    <AppTextInput
                        style={[styles.inputTxt, isFormContainerClicked && styles.focusedBorder,
                        ]}
                        placeholder="Search User"
                        onFocus={() => setIsFormContainerClicked(true)}
                        onBlur={() => setIsFormContainerClicked(false)}
                        // value={tableCaption}setSearchQuery
                        onChangeText={setUsernameSearchText}
                    // onChangeText={setSearchQuery}
                    />
                    <View style={styles.dimacation}></View>
                    <SearchIcon color={Colours.DARKGRAY} />
                </View>
            </View>
            {foundUser ? (<View style={styles.searchFriendsResultContainer}>

                {foundUser && foundUser.data?.username ? (
                    <TouchableOpacity style={styles.profileContainer}
                        onPress={handleMeezaTransfer}
                    >
                        <View style={styles.profileAndButtonContainer}>
                            <View style={styles.profileAndTextContainer}>

                                <Image source={{ uri: foundUser.data.profilePicture }} style={styles.userImage} />
                                <View>
                                    <Text style={styles.usernameTxt}>{foundUser.data.username}</Text>
                                    <Text style={styles.realNamesTxt}>{foundUser.data.firstname} {foundUser.data.lastname}</Text>
                                </View>

                                {/* <Text style={{color:Colours.DARKGRAY, fontFamily:'Sen-Regular' }}>Welcome</Text> */}
                            </View>
                        </View>
                    </TouchableOpacity>) : ('')}

            </View>) : ("")}

            <View style={styles.searchFriendsResultContainer}>
                <View style={styles.JoinedNumber}>
                    <Text style={styles.titleTxt} >Friends</Text>
                    <Text style={styles.sectionalTxt}>| :</Text>
                </View>
                <View style={styles.profileContainer}>
                    {friendsList && friendsList.length > 0 ? (

                        <FlatList
                            data={friendsList}
                            scrollEnabled={false}
                            keyExtractor={(friends) => friends._id}
                            renderItem={({ item: friends }) => (
                                <TouchableOpacity style={styles.profileAndButtonContainer}
                                    onPress={() => handleMeezaTransferFriends(friends)}
                                >
                                    <View style={styles.profileAndTextContainer}>

                                        <Image source={{ uri: friends?.profilePicture }} style={styles.userImage} />
                                        <View>
                                            <Text style={styles.usernameTxt}>{friends?.username}</Text>
                                            <Text style={styles.realNamesTxt}>{friends?.firstname} {friends?.lastname}</Text>
                                        </View>



                                        {/* <Text style={{color:Colours.DARKGRAY, fontFamily:'Sen-Regular' }}>Welcome</Text> */}
                                    </View>
                                </TouchableOpacity>
                            )} />
                    ) : ("")
                    }
                </View>
            </View>

            <Modal
                visible={showCreateMeezaTransferTo}
                animationType="fade"
                onRequestClose={() => setShowCreateMeezaTransferTo(false)}
            >
                <CreateMeezaTransferTo
                    username={username}
                    firstname={firstname}
                    lastname={lastname}
                    photo={photo}
                    hideModal={() => setShowCreateMeezaTransferTo(false)}
                />
            </Modal>
            <Toast config={toastConfig} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        margin: dynamicSpacing(15)
    },
    searchBox: {
        display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        padding: dynamicSpacing(15),
        backgroundColor: 'white',
        borderRadius: dynamicSize(10),

    },
    searchContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',

    },
    searchFriendsResultContainer: {
        display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        padding: dynamicSpacing(15),
        marginTop: dynamicSpacing(15),
        // marginBottom: dynamicSpacing(15),
        backgroundColor: 'white',
        borderRadius: dynamicSize(10),
    },
    titleTxt: {
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(10),
        fontSize: dynamicFontSize(15),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Regular',
    },

    sectionalTxt: {
        paddingLeft: dynamicSpacing(1),
        paddingBottom: 0,
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
    },


    JoinedNumber: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: dynamicSpacing(1),
    },

    inputTxt: {
        height: dynamicSize(40),
        width: width * 0.75, // Makes it responsive based on screen width
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(2.5),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: dynamicSpacing(10),
        marginRight: dynamicSpacing(10),
    },

    focusedBorder: {
        borderColor: Colours.PRIMARY,
        borderWidth: dynamicSize(1.5),
    },

    dimacation: {
        backgroundColor: Colours.DARKLIGHTGRAY,
        height: dynamicSize(20),
        width: dynamicSize(1),
    },

    profileContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: dynamicSpacing(10),
        gap: dynamicSpacing(10),
    },

    profileAndButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: width * 0.8, // Adjust width dynamically
        alignItems: 'center',
    },

    profileAndTextContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: dynamicSpacing(10),
        gap: dynamicSpacing(10),
    },
    userImage: {
        width: dynamicSize(45),
        height: dynamicSize(45),
        borderRadius: 99, // Keeps it circular
    },
    usernameTxt: {
        fontSize: dynamicFontSize(16),
        color: Colours.DARKGRAY,
        fontFamily: 'Sen-Regular',
    },
    realNamesTxt: {
        fontSize: dynamicFontSize(13),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Regular',
    },
})

export default TransferTo
